var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"text-uppercase text-center",attrs:{"title":"Qr de usuario a buscar"}},[(_vm.mostrar)?_c('qrcode-reader',{on:{"decode":_vm.onDecode}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70e4bb9d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/carnets/validate.vue
// module id = null
// module chunks = 